import React, { useState, useEffect, useMemo } from "react";
import { useParams } from "react-router-dom";
import { Controller, useForm } from "react-hook-form";
import { Modal, Dropdown, DropdownButton } from "react-bootstrap";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import swal from "sweetalert";
import { httpAdmin } from "../../../Apis/commonApis";
import { currentCareSiteId } from "../../../redux-toolkit/reducer/switchSites";
import { getChangedKeysVals } from "../../../utils/CommonFunctions";
import AwsLocation from "../../../utils/AwsLocation";
import { relationshipValues } from "../keyContactConstant";
import { useSelector } from "react-redux";

const KeyContactModal = (props) => {
  const {
    clientId,
    openAddEditModal,
    handleCloseModal,
    editKeyContactData,
    isFromLead,
  } = props;
  const { currentSiteCountryCode } = useSelector(
    (state) => state.caresiteDataReducer
  );
  const {
    register,
    handleSubmit,
    reset,
    control,
    setValue,
    formState: { errors },
  } = useForm();
  // const [locErrorMsg, setlocErrorMsg] = useState(true);
  const [location, setlocation] = useState(null);
  const [mobileNo, setmobileNo] = useState("");

  useEffect(() => {
    if (editKeyContactData) {
      setmobileNo(editKeyContactData.phone?.toString());
    }
  }, [editKeyContactData]);

  function resetData() {
    setmobileNo("");
    setlocation("");
    reset();
  }

  function onAddEditContactSubmit(postdata) {
    const userData = JSON.parse(localStorage.getItem("userData"));
    let phoneNoVal = mobileNo
      ? mobileNo
      : editKeyContactData?.phone
      ? editKeyContactData?.phone?.toString()
      : "";
    let formVals = { ...postdata };
    if (location) {
      formVals.address = location?.Label;
    }
    formVals.phone = phoneNoVal;
    let idVals = {
      adminId: userData._id,
      careHomeId: currentCareSiteId,
      clientId: clientId,
    };
    if (editKeyContactData) {
      let editData = getChangedKeysVals(editKeyContactData, formVals);
      idVals.keycontact_id = editKeyContactData._id;
      let body = { ...idVals, ...editData };
      editKeyContacts(body);
    } else {
      let body = { ...idVals, ...formVals };
      createKeyContacts(body);
    }
  }

  const createKeyContacts = async (body) => {
    const result = await httpAdmin(
      `keyContact/${clientId}`,
      "post",
      body,
      null
    );
    swal(
      result.status ? "Success" : "Failed",
      result.message,
      result.status ? "success" : "error"
    );
    if (result.status) {
      resetData();
      handleCloseModal(result);
    }
  };

  const editKeyContacts = async (body) => {
    const result = await httpAdmin(
      `editKeycontact/${clientId}`,
      "post",
      body,
      null
    );
    swal(
      result.status ? "Success" : "Failed",
      result.message,
      result.status ? "success" : "error"
    );
    if (result.status) {
      resetData();
      handleCloseModal(result);
    }
  };

  function awsLocationHandler(locVal) {
    setlocation(locVal);
  }

  function phoneInput(value, data) {
    setmobileNo(value);
  }

  return (
    <>
      <Modal show={openAddEditModal} onHide={() => handleCloseModal(null)}>
        <Modal.Body>
          <div
            tabIndex="-1"
            aria-labelledby="exampleModalLabel"
            aria-hidden="true"
          >
            <form onSubmit={handleSubmit(onAddEditContactSubmit)}>
              <div className="modal-content">
                <div className="modal-header">
                  <h5 className="modal-title" id="exampleModalLabel">
                    {editKeyContactData ? "Edit" : "Add"} Key Contact
                  </h5>
                  <button
                    type="button"
                    className="btn-close"
                    data-bs-dismiss="modal"
                    aria-label="Close"
                    onClick={() => handleCloseModal(null)}
                  ></button>
                </div>
                <div className="modal-body">
                  <div className="row">
                    <div className="col-md-12 mb-3">
                      <label className="form-label">Name</label>
                      <input
                        type="text"
                        className="form-control"
                        defaultValue={editKeyContactData?.name}
                        {...register("name", {
                          required: true,
                          pattern: /^[A-Za-z ]+$/i,
                        })}
                      />
                      {errors?.name?.type === "required" && (
                        <p className="error_style">This field is required</p>
                      )}
                    </div>
                    <div className="col-md-12 mb-3">
                      <label className="form-label">Address</label>
                      <AwsLocation
                        awsLocationHandler={awsLocationHandler}
                        defaultVal={editKeyContactData?.address}
                      />
                    </div>

                    <div className="col-md-12 mb-3">
                      <label className="form-label">Email</label>
                      <input
                        type="email"
                        className="form-control"
                        defaultValue={editKeyContactData?.email}
                        {...register("email", {
                          required: false,
                          // pattern:
                          //   /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
                        })}
                      />
                      {errors?.email?.type === "pattern" && (
                        <p className="error_style">Invalid email address</p>
                      )}
                      {errors?.email?.type === "required" && (
                        <p className="error_style">This field is required</p>
                      )}
                    </div>

                    <div className="col-md-12 mb-3">
                      <label className="form-label">Contact Type</label>
                      {/* React Select Along with React Hook Form */}
                      <select
                        className="form-select"
                        defaultValue={editKeyContactData?.contactType}
                        {...register("contactType", { required: true })}
                        name="contactType"
                      >
                        <option value="">--Select--</option>
                        <option value="Personal">Personal</option>
                        <option value="Professional">Professional</option>
                      </select>
                      {errors?.contactType?.type === "required" && (
                        <p className="error_style">This field is required</p>
                      )}
                    </div>

                    <div className="col-md-12 mb-3">
                      <label className="form-label">Consent Authority</label>
                      {/* React Select Along with React Hook Form */}
                      <select
                        className="form-select"
                        defaultValue={editKeyContactData?.consentAuthority}
                        {...register("consentAuthority", {
                          required: true,
                        })}
                        name="consentAuthority"
                      >
                        <option value="">--Select--</option>
                        <option value="yes">Yes</option>
                        <option value="no">No</option>
                      </select>
                      {errors?.consentAuthority?.type === "required" && (
                        <p className="error_style">This field is required</p>
                      )}
                    </div>
                    {isFromLead !== true && (
                      <div className="col-md-12 mb-3">
                        <label className="form-label">Household Member</label>
                        {/* React Select Along with React Hook Form */}
                        <select
                          className="form-select"
                          defaultValue={editKeyContactData?.houseHoldMember}
                          {...register("houseHoldMember")}
                          name="houseHoldMember"
                        >
                          <option value="">--Select--</option>
                          <option value="yes">Yes</option>
                          <option value="no">No</option>
                          <option value="unknown">Unknown</option>
                        </select>
                      </div>
                    )}

                    <div className="col-md-12 mb-3">
                      <label className="form-label">Relationship</label>
                      {/* React Select Along with React Hook Form */}
                      <select
                        className="form-select"
                        defaultValue={editKeyContactData?.relationship}
                        name="relationship"
                        {...register("relationship", { required: true })}
                      >
                        <option value="">--Select--</option>
                        {relationshipValues.Personal.map((item, i) => {
                          return (
                            <option value={item.label} key={i}>
                              {item.label}
                            </option>
                          );
                        })}
                      </select>
                      {errors?.relationship?.type === "required" && (
                        <p className="error_style">This field is required</p>
                      )}
                    </div>
                    {isFromLead !== true && (
                      <div className="col-md-12 mb-3">
                        <label className="form-label">
                          Relationship Description
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          placeholder="Relationship Description"
                          defaultValue={
                            editKeyContactData?.relationshipDescription
                          }
                          {...register("relationshipDescription")}
                        />
                      </div>
                    )}

                    <div className="col-md-12 mb-3">
                      <label className="form-label">Telephone</label>

                      <PhoneInput
                        defaultMask={mobileNo}
                        country={currentSiteCountryCode}
                        value={mobileNo}
                        onChange={phoneInput}
                        isValid={(value, country) => {
                          if (
                            value.match(
                              /\+?\d{1,9}?[-.\s]?\(?\d{1,3}?\)?[-.\s]?\d{1,4}[-.\s]?\d{1,4}[-.\s]?\d{1,9}/g
                            )
                          ) {
                            return true;
                          } else {
                            return false;
                          }
                        }}
                      />
                      {errors.phoneNo && (
                        <p className="error_style">{errors.phoneNo.message}</p>
                      )}
                    </div>
                  </div>
                </div>
                <div className="modal-footer">
                  <button
                    type="submit"
                    className="btn btn-success"
                    // data-bs-dismiss="modal"
                    // onClick={}
                  >
                    {editKeyContactData ? "Save" : "Create"}
                  </button>
                </div>
              </div>
            </form>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default KeyContactModal;
